

import { createSlice } from '@reduxjs/toolkit';
import { Project } from '@brg/api';

export interface IChapterPager {
    chapter: Project;
}

const INITIAL_STATE ={
    chapter: undefined,
}

const chapterPagerSlice = createSlice({
    name: 'chapterPager',
    initialState: INITIAL_STATE,
    reducers: {
        setChapter: (state, action) => {
            state.chapter = action.payload
        },
        reset: (state) => {
            state = INITIAL_STATE;
        }
    },
});

export default chapterPagerSlice;
export const chapterPagerSliceReducer = chapterPagerSlice.reducer;
export const getChapter = (store: { chapterPager: IChapterPager }): IChapterPager => store.chapterPager;


import { createSlice } from '@reduxjs/toolkit';
import { Project } from '@brg/api';

export interface IChapterPager {
    chapter: Project;
}

const INITIAL_STATE ={
    chapter: undefined,
}

const chapterPagerSlice = createSlice({
    name: 'chapterPager',
    initialState: INITIAL_STATE,
    reducers: {
        setChapter: (state, action) => {
            state.chapter = action.payload
        },
        reset: (state) => {
            state = INITIAL_STATE;
        }
    },
});

export default chapterPagerSlice;
export const chapterPagerSliceReducer = chapterPagerSlice.reducer;
export const getChapter = (store: { chapterPager: IChapterPager }): IChapterPager => store.chapterPager;
